import React, { HTMLAttributes } from 'react';
import { AppElement, AppFC } from '../../../interfaces';

export const Line: AppFC<HTMLAttributes<HTMLDivElement>> = ({
  children, className, ...props
}): AppElement => (
  <div className={`h-[1px] w-full bg-[#242932] ${className || ''}`} {...props} />
);
